import { initClientFromCookies, type Client } from "trailbase";

export const createClient = async (): Promise<Client> =>
  initClientFromCookies(window.location.origin);

export const loginUrl = (): string => {
  const redirect = encodeURIComponent(
    window.location.pathname + window.location.search + window.location.hash,
  );
  return `/_/auth/login?redirect_uri=${redirect}`;
};
